import { useCategoryContext, useProviderComparePageContext } from "../Context";
import React from "react";
import {
    CategoryChartEntity,
    getCategoryChartFromGQResult,
    GraphQLResponse,
    KpiReportTemplate as KpiReportTemplateType
} from "../processors";
import { GET_CATEGORY_CHART_BY_CATEGORY_ID_PARAMS } from "../graphql";
import { useQuery } from "@apollo/client";
import { LoadingIndicator } from "../LoadingIndicator";
import { CategoryChart } from "./CategoryChart";
import _ from "lodash";

export interface KpiReportTemplateProps extends KpiReportTemplateType {
    className?: string;
    truncate?: {
        height: (element: Element) => number;
    };
}
export const KpiReportTemplate: React.FC<KpiReportTemplateProps> = ({ visGroup, truncate, className }) => {
    const { category } = useCategoryContext();

    const { query, options } = GET_CATEGORY_CHART_BY_CATEGORY_ID_PARAMS(
        [category?.tid].filter(d => d != null),
        visGroup
    );

    const { loading, data } = useQuery<GraphQLResponse<CategoryChartEntity[]>>(query, options);
    const categoryCharts = _.orderBy(getCategoryChartFromGQResult(data?.result ?? []), d => d.weight, "asc");

    const { contextType } = useProviderComparePageContext();

    return (
        <div className={`row ${contextType ?? ""}`}>
            <div className="col-12">{loading === true && <LoadingIndicator />}</div>
            {categoryCharts?.map((d, index) => {
                return (
                    <CategoryChart
                        key={index}
                        {...d}
                        className={index === 0 ? `category-chart-first ${d.className ?? "col-12"}` : d.className}
                    />
                );
            })}
        </div>
    );
};
